import type { SceneStoreGetState, SceneStoreSetState } from "../sceneStore.types";
import type { JointActions } from "./actionTypes";
import { createJointManagementActions } from "./jointManagementActions";
import { createJointValueActions } from "./jointValueActions";

export { embedJointsIntoBodies, findJointInMap } from "./jointActionUtils";

export const createJointActions = (
  set: SceneStoreSetState,
  get: SceneStoreGetState
): JointActions => ({
  ...createJointManagementActions(set, get),
  ...createJointValueActions(set, get),
});
